import axios from "axios";
import Post from "../Post";
import getToken from "../token";

export default function newMessage(type, value) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": "*",
    origin: "https://manager.asqtest.ir",
  };
  const data = new FormData();
  data.append("token", getToken());
  //data.append("counselingId", id);
  data.append("type", type);
  if (type === "audio") {
    data.append("value", {
      uri: value,
      type: "audio/m4a", // or photo.type
      name: "avatar.m4a",
    });
  } else if (type === "image") {
    data.append("value", {
      uri: value,
      type: "image/png", // or photo.type
      name: "avatar.png",
    });
  } else {
    data.append("value", value);
  }

  return axios.post("https://api.asqtest.ir/ticket/sendTicketUser", data, {
    headers: headers,
  });
}
